import { createContext, useContext } from "react";
export const pagesContext = createContext([]);
pagesContext.displayName = "Pages";
export const PagesProvider = pagesContext.Provider;
export const usePages = () => useContext(pagesContext);
//# sourceMappingURL=pagesContext.js.map